export default "__VITE_ASSET__4OxISMyj__"